import http from "../../services/http";

const getEstados = async () => {
  return await http("get", `v1/estados/listar`, []);
};

export { getEstados };
